import React, { memo, useEffect, useState } from 'react';
import {
  Marker,
  Polygon,
  DrawingManager,
  InfoWindow,
} from '@react-google-maps/api';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import SelectedOrdersCard from './SelectedOrdersCard';
import OrdersWithoutPoint from './OrdersWithoutPoint';
import { wsFindBy, wsPost } from 'services/WService';
import Button from 'components/CustomButtons/Button';
import { Map, Visibility } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import { nthIndexOf } from 'hooks/Pipe';
import { Link } from 'react-router-dom';
import { formatDate } from 'hooks/Pipe';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

function ProgMap(props) {
  const { zoneId, dataFilter, setCheckedOrders, generating, dataKey } = props;
  const [routes, setRoutes] = useState([]);
  const [polygons, setPolygons] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [ordersWithoutPoint, setOrdersWithoutPoint] = useState([]);
  const [routesWithoutPoint, setRoutesWithoutPoint] = useState([]);
  const [selectedOrdersIds, setSelectedOrdersIds] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: -14.07543457346045,
    lng: -75.73423487506565,
  });
  const [mapZoom, setMapZoom] = useState(14);
  const [processing, setProcessing] = useState(false);
  const [infoWindowData, setInfoWindowData] = useState();
  async function getData(mapCenter = true) {
    let response = await wsFindBy('base/route/with-orders-map', {
      ...dataFilter,
      base_zone_id: zoneId,
    });

    if (response.success) {
      if (response.data.length > 0) {
        if (mapCenter) {
          setMapCenter({
            lat: response.data[0].geometry[0].lat,
            lng: response.data[0].geometry[0].lng,
          });
        }
        setOrdersWithoutPoint(response.orders_without_point);
        setRoutesWithoutPoint(response.routes_without_point);
      }
      setRoutes(response.data);
    }
  }

  function onPolygonComplete(polygon) {
    let coords = polygon.getPath().getArray();
    if (coords.length < 3) {
      polygon.setMap(null);
      return;
    }
    coords = coords.map((point) => {
      return {
        lat: point.lat(),
        lng: point.lng(),
      };
    });
    setPolygons((polygons) => [...polygons, coords]);
    polygon.setMap(null);
  }

  async function getOrdersInPolygons() {
    if (polygons.length > 0) {
      setProcessing(true);
      let res = await wsPost('prog/sheet-distribution/orders-by-polygons', {
        base_zone_id: zoneId,
        start_date: dataFilter.start_date,
        end_date: dataFilter.end_date,
        polygons,
      });
      setSelectedOrders(res.data);
      setCheckedOrders([
        ...res.data,
        ...routesWithoutPoint.reduce(
          (prev, route) => [...prev, ...route.orders.filter((order) => order.checked === true)],
          [],
        ),
      ]);
      setSelectedOrdersIds(res.data.map((order) => parseInt(order.id)));
      setProcessing(false);
    } else {
      if (selectedOrders.length > 0) {
        setSelectedOrders([]);
        setSelectedOrdersIds([]);
        setCheckedOrders([
          ...routesWithoutPoint.reduce(
            (prev, route) => [...prev, ...route.orders.filter((order) => order.checked === true)],
            [],
          ),
        ]);
      }
    }
  }

  useEffect(() => {
    if (zoneId === undefined) return;
    if (dataFilter === undefined) return;
    getData();
  }, [zoneId, dataFilter]);

  useEffect(() => {
    if (dataKey === 0) return;
    getData(false);
    setPolygons([]);
    setSelectedOrdersIds([]);
    setOrdersWithoutPoint([]);
    setRoutesWithoutPoint([]);
    setCheckedOrders([]);
  }, [dataKey]);

  useEffect(() => {
    setCheckedOrders([
      ...selectedOrders,
      ...routesWithoutPoint.reduce(
        (prev, route) => [...prev, ...route.orders.filter((order) => order.checked === true)],
        [],
      ),
    ]);
  }, [routesWithoutPoint]);

  useEffect(() => {
    getOrdersInPolygons();
  }, [polygons]);

  return (
    <GridContainer>
      {/* Mapa */}
      <GridItem xs={12} style={{ position: 'relative' }}>
        <CardContainer title="Mapa" collapse icon={<Map />}>
          {(processing || generating) && (
            <div
              style={{
                width: '100%',
                height: '80%',
                minHeight: '500px',
                backgroundColor: '#0000008a',
                position: 'absolute',
                zIndex: 100,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  display: 'block',
                  fontSize: '40px',
                  width: '100%',
                  textAlign: 'center',
                  color: 'white',
                }}
              >
                Procesando...
              </span>
            </div>
          )}
          <GoogleMapCustom
            mapContainerStyle={{
              width: '100%',
              height: '400px',
            }}
            zoom={mapZoom}
            center={mapCenter}
            options={{
              disableDoubleClickZoom: true,
            }}
          >
            <DrawingManager
              onPolygonComplete={onPolygonComplete}
              drawingMode="polygon"
              options={{
                drawingControlOptions: {
                  position: 7,
                  drawingModes: ['polygon'],
                },
              }}
            />
            {/* Rutas */}
            {routes.map((route) => {
              return (
                <Polygon
                  key={route.id}
                  path={route.geometry}
                  options={{
                    fillColor: route.layer.color,
                  }}
                />
              );
            })}

            {/* Poligonos para seleccionar pedidos */}
            {polygons.map((polygon, i) => {
              return (
                <Polygon
                  key={i}
                  path={polygon}
                  onDblClick={() => {
                    if (window.confirm('Eliminar el poligono seleccionado ?')) {
                      setPolygons((polygons) => {
                        let newPolygons = [...polygons];
                        newPolygons.splice(i, 1);
                        return newPolygons;
                      });
                    }
                  }}
                />
              );
            })}

            {/* Pedidos */}
            {routes.map((route) => {
              return route.orders.map((order) => {
                return (
                  <Marker
                    key={order.id}
                    position={{
                      lat: parseFloat(order.lat),
                      lng: parseFloat(order.lng),
                    }}
                    onClick={() => setInfoWindowData(order)}
                    icon={selectedOrdersIds.includes(order.id) ? '/img/marker.png' : undefined}
                    options={{
                      label: {
                        color: 'white',
                        className: 'map-label',
                        text:
                          nthIndexOf(order.CardName, ' ', 2) !== -1
                            ? order.CardName.substr(0, nthIndexOf(order.CardName, ' ', 2))
                            : order.CardName,
                      },
                    }}
                  />
                );
              });
            })}

            {/* InfoWindow */}
            {infoWindowData !== undefined && (
              <InfoWindow
                position={{
                  lat: parseFloat(infoWindowData.lat),
                  lng: parseFloat(infoWindowData.lng),
                }}
                onCloseClick={() => setInfoWindowData(undefined)}
                options={{
                  pixelOffset: {
                    width: 0,
                    height: -25,
                  },
                }}
              >
                <div style={{ position: 'relative' }}>
                  <Button
                    justIcon
                    round
                    simple
                    color="primary"
                    style={{ position: 'absolute', top: '-20px', right: 0 }}
                  >
                    <Link
                      to={`/admin/ventas/operaciones/pedidos/#${infoWindowData.id}`}
                      target="_blank"
                    >
                      <Visibility />
                    </Link>
                  </Button>
                  <h5>
                    {infoWindowData.CardCode}
                    {infoWindowData.CardName}
                  </h5>
                  <li>
                    <span>Monto: </span>
                    S/ {parseFloat(infoWindowData.total_order).toFixed(2)}
                  </li>
                  <li>
                    <span>Dir: </span>
                    {infoWindowData.Address2}
                  </li>
                  <li>
                    <span>Fecha: </span>
                    {formatDate(infoWindowData.date_order)}
                  </li>
                  <li>
                    <span>Vendedor: </span>
                    {infoWindowData.SlpName}
                  </li>
                </div>
              </InfoWindow>
            )}
          </GoogleMapCustom>
        </CardContainer>
      </GridItem>

      {/* Listado de Rutas/Pedidos */}
      <GridItem xs={12}>
        <SelectedOrdersCard
          selectedOrders={selectedOrders}
          selectedOrdersIds={selectedOrdersIds}
          setInfoWindowData={setInfoWindowData}
          routes={routes}
        />
      </GridItem>

      <GridItem xs={12}>
        <CardContainer title={`Pedidos sin punto (${ordersWithoutPoint.length})`} collapse>
          <OrdersWithoutPoint
            selectedOrders={selectedOrders}
            selectedOrdersIds={selectedOrdersIds}
            routes={routesWithoutPoint}
            setRoutes={setRoutesWithoutPoint}
          />
        </CardContainer>
      </GridItem>
    </GridContainer>
  );
}

export default memo(ProgMap);
